import Bullets from 'components/decorations/Bullets';
import Stripes from 'components/decorations/Stripes';

const Decorations = {
  Bullets,
  Stripes
};

export default Decorations;
